import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import SingleSelectFilterModal from '../../components/modals/SingleSelectFilterModal';
import Chart from '../../components/ui/Chart';
import { 
  BarChart3, 
  Plus, 
  Edit, 
  Trash2, 
  Play, 
  Pause, 
  Filter,
  Search,
  ChevronDown,
  Check,
  ArrowUp,
  ArrowDown,
  Target,
  Clock,
  AlertTriangle,
  CheckCircle,
  Users,
  RefreshCw,
  Download,
  Upload,
  Settings,
  Zap,
  RotateCcw,
  Eye,
  EyeOff,
  Copy,
  ExternalLink,
  TrendingUp,
  TrendingDown,
  Star,
  Crown,
  Shield,
  Activity,
  UserCheck,
  Timer,
  Brain,
  Route,
  Lightning,
  Cpu,
  Database,
  Monitor,
  UserPlus,
  UserMinus,
  Calendar,
  Mail,
  Phone,
  Send,
  Archive,
  Unarchive,
  History,
  AlertCircle,
  Info,
  HelpCircle,
  XCircle,
  CheckCircle2,
  Clock3,
  CalendarDays,
  UserX,
  UserCog,
  UserSearch,
  UserEdit,
  Globe,
  Link,
  Key,
  Lock,
  Unlock,
  TestTube,
  Bug,
  Wifi,
  WifiOff,
  Server,
  Cloud,
  CloudOff,
  Terminal,
  Code,
  Hash,
  Layers,
  Box,
  Package,
  Archive as ArchiveIcon,
  File,
  Folder,
  FolderOpen,
  FileCode,
  FileJson,
  FileText as FileTextIcon,
  FileImage,
  FileVideo,
  FileAudio,
  FileSpreadsheet,
  FilePdf,
  FileZip,
  FileCheck,
  FileX,
  FilePlus,
  FileMinus,
  FileEdit,
  FileSearch,
  FileSlash,
  FileWarning,
  FileQuestion,
  FileHeart,
  FileClock,
  FileUp,
  FileDown,
  FileLeft,
  FileRight,
  FileBarChart,
  FilePieChart,
  FileLineChart,
  FileScissors,
  FileType,
  FileSymlink,
  FileStack,
  FileTree,
  FileBinary,
  FileCog,
  FileSettings,
  FileShield,
  FileLock,
  FileUnlock,
  FileKey,
  FileCertificate,
  FileSignature,
  FileVerified,
  FileBadge,
  FileTag,
  FileLabel,
  FileBookmark,
  FileStar,
  FileFlag,
  FileAlert,
  FileInfo,
  FileHelp,
  FileMessage,
  FileComment,
  FileChat,
  FileMail,
  FilePhone,
  FileVideo as FileVideoIcon,
  FileAudio as FileAudioIcon,
  FileImage as FileImageIcon,
  FileSpreadsheet as FileSpreadsheetIcon,
  FilePdf as FilePdfIcon,
  FileZip as FileZipIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  FilePlus as FilePlusIcon,
  FileMinus as FileMinusIcon,
  FileEdit as FileEditIcon,
  FileSearch as FileSearchIcon,
  FileSlash as FileSlashIcon,
  FileWarning as FileWarningIcon,
  FileQuestion as FileQuestionIcon,
  FileHeart as FileHeartIcon,
  FileClock as FileClockIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileLeft as FileLeftIcon,
  FileRight as FileRightIcon,
  FileBarChart as FileBarChartIcon,
  FilePieChart as FilePieChartIcon,
  FileLineChart as FileLineChartIcon,
  FileScissors as FileScissorsIcon,
  FileType as FileTypeIcon,
  FileSymlink as FileSymlinkIcon,
  FileStack as FileStackIcon,
  FileTree as FileTreeIcon,
  FileBinary as FileBinaryIcon,
  FileCog as FileCogIcon,
  FileSettings as FileSettingsIcon,
  FileShield as FileShieldIcon,
  FileLock as FileLockIcon,
  FileUnlock as FileUnlockIcon,
  FileKey as FileKeyIcon,
  FileCertificate as FileCertificateIcon,
  FileSignature as FileSignatureIcon,
  FileVerified as FileVerifiedIcon,
  FileBadge as FileBadgeIcon,
  FileTag as FileTagIcon,
  FileLabel as FileLabelIcon,
  FileBookmark as FileBookmarkIcon,
  FileStar as FileStarIcon,
  FileFlag as FileFlagIcon,
  FileAlert as FileAlertIcon,
  FileInfo as FileInfoIcon,
  FileHelp as FileHelpIcon,
  FileMessage as FileMessageIcon,
  FileComment as FileCommentIcon,
  FileChat as FileChatIcon,
  FileMail as FileMailIcon,
  FilePhone as FilePhoneIcon,
  MessageSquare,
  ThumbsUp,
  ThumbsDown,
  Smile,
  Frown,
  Meh
} from 'lucide-react';
import { useDataContext } from '../../contexts/DataContext';

const ChatAnalytics = () => {
  const { getMockData, updateMockData } = useDataContext();
  const [analytics, setAnalytics] = useState({});
  const [agents, setAgents] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterPeriod, setFilterPeriod] = useState('30days');
  const [filterAgent, setFilterAgent] = useState('all');
  const [showPeriodFilter, setShowPeriodFilter] = useState(false);
  const [showAgentFilter, setShowAgentFilter] = useState(false);

  useEffect(() => {
    loadChatAnalyticsData();
  }, []);

  const loadChatAnalyticsData = async () => {
    try {
      const analyticsData = getMockData('chatAnalytics');
      const agentsData = getMockData('agents');
      const sessionsData = getMockData('chatSessions');
      
      setAnalytics(analyticsData || {});
      setAgents(agentsData?.agents || []);
      setSessions(sessionsData?.sessions || []);
    } catch (error) {
      console.error('Failed to load chat analytics data:', error);
    }
  };

  const handleGenerateReport = () => {
    setIsGeneratingReport(true);
  };

  const handleExportAnalytics = () => {
    alert('Exporting chat analytics...');
  };

  const getSatisfactionIcon = (rating) => {
    if (rating >= 4.5) return Smile;
    if (rating >= 3.5) return Meh;
    return Frown;
  };

  const getSatisfactionColor = (rating) => {
    if (rating >= 4.5) return 'green';
    if (rating >= 3.5) return 'yellow';
    return 'red';
  };

  const filteredSessions = sessions.filter(session => {
    const matchesSearch = session.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         session.subject.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesAgent = filterAgent === 'all' || session.agentId === filterAgent;
    return matchesSearch && matchesAgent;
  });

  const mockAnalytics = {
    totalSessions: 1247,
    activeSessions: 23,
    avgResponseTime: '2.3 minutes',
    customerSatisfaction: 4.7,
    resolutionRate: 94.2,
    avgSessionDuration: '18.5 minutes',
    peakHours: '2:00 PM - 4:00 PM',
    busiestDay: 'Tuesday'
  };

  const agentPerformance = [
    {
      id: 'agent-1',
      name: 'Sarah Johnson',
      sessionsHandled: 156,
      avgResponseTime: '1.8 minutes',
      satisfaction: 4.8,
      resolutionRate: 96.1,
      status: 'online'
    },
    {
      id: 'agent-2',
      name: 'David Wilson',
      sessionsHandled: 142,
      avgResponseTime: '2.1 minutes',
      satisfaction: 4.6,
      resolutionRate: 94.3,
      status: 'busy'
    },
    {
      id: 'agent-3',
      name: 'Mike Chen',
      sessionsHandled: 128,
      avgResponseTime: '2.5 minutes',
      satisfaction: 4.5,
      resolutionRate: 92.8,
      status: 'away'
    },
    {
      id: 'agent-4',
      name: 'Lisa Park',
      sessionsHandled: 134,
      avgResponseTime: '2.0 minutes',
      satisfaction: 4.7,
      resolutionRate: 95.2,
      status: 'online'
    }
  ];

  const recentSessions = [
    {
      id: 'CHAT-2025-001',
      customerName: 'John Smith',
      subject: 'Login Issues with Mobile App',
      agentName: 'Sarah Johnson',
      status: 'resolved',
      duration: '15 minutes',
      satisfaction: 4.5,
      messagesCount: 12,
      startedAt: '2025-01-15T20:00:00Z',
      endedAt: '2025-01-15T20:15:00Z'
    },
    {
      id: 'CHAT-2025-002',
      customerName: 'Emily Davis',
      subject: 'Billing Question',
      agentName: 'David Wilson',
      status: 'active',
      duration: '8 minutes',
      satisfaction: null,
      messagesCount: 6,
      startedAt: '2025-01-15T19:45:00Z',
      endedAt: null
    },
    {
      id: 'CHAT-2025-003',
      customerName: 'Robert Brown',
      subject: 'Feature Request',
      agentName: 'Mike Chen',
      status: 'resolved',
      duration: '22 minutes',
      satisfaction: 4.8,
      messagesCount: 18,
      startedAt: '2025-01-15T19:20:00Z',
      endedAt: '2025-01-15T19:42:00Z'
    }
  ];

  const chartData = {
    volumeOverTime: [
      { hour: '9 AM', sessions: 12, satisfaction: 4.6 },
      { hour: '10 AM', sessions: 18, satisfaction: 4.7 },
      { hour: '11 AM', sessions: 25, satisfaction: 4.5 },
      { hour: '12 PM', sessions: 32, satisfaction: 4.8 },
      { hour: '1 PM', sessions: 28, satisfaction: 4.6 },
      { hour: '2 PM', sessions: 45, satisfaction: 4.7 },
      { hour: '3 PM', sessions: 52, satisfaction: 4.8 },
      { hour: '4 PM', sessions: 38, satisfaction: 4.6 },
      { hour: '5 PM', sessions: 22, satisfaction: 4.5 }
    ],
    satisfactionTrends: [
      { day: 'Mon', satisfaction: 4.6 },
      { day: 'Tue', satisfaction: 4.7 },
      { day: 'Wed', satisfaction: 4.5 },
      { day: 'Thu', satisfaction: 4.8 },
      { day: 'Fri', satisfaction: 4.7 },
      { day: 'Sat', satisfaction: 4.6 },
      { day: 'Sun', satisfaction: 4.5 }
    ],
    resolutionTime: [
      { category: 'Technical', avgTime: '12.5 min', sessions: 456 },
      { category: 'Billing', avgTime: '8.2 min', sessions: 234 },
      { category: 'General', avgTime: '6.8 min', sessions: 345 },
      { category: 'Feature Request', avgTime: '18.3 min', sessions: 123 },
      { category: 'Bug Report', avgTime: '15.7 min', sessions: 89 }
    ]
  };

  const analyticsMetrics = [
    {
      title: 'Total Sessions',
      value: mockAnalytics.totalSessions,
      icon: MessageSquare,
      color: 'blue',
      trend: '+12%',
      trendDirection: 'up'
    },
    {
      title: 'Active Sessions',
      value: mockAnalytics.activeSessions,
      icon: Activity,
      color: 'green',
      trend: '+3',
      trendDirection: 'up'
    },
    {
      title: 'Avg Response Time',
      value: mockAnalytics.avgResponseTime,
      icon: Timer,
      color: 'green',
      trend: '-0.2 min',
      trendDirection: 'down'
    },
    {
      title: 'Customer Satisfaction',
      value: mockAnalytics.customerSatisfaction,
      icon: Star,
      color: 'green',
      trend: '+0.1',
      trendDirection: 'up'
    }
  ];

  return (
    <div className="chat-analytics p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="mb-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Chat Analytics</h1>
            <p className="text-gray-600">Monitor chat support quality and efficiency</p>
          </div>
          <div className="flex items-center space-x-4">
            <Button onClick={handleGenerateReport}>
              <Plus className="h-4 w-4 mr-2" />
              Generate Report
            </Button>
            <Button variant="outline" onClick={handleExportAnalytics}>
              <Download className="h-4 w-4 mr-2" />
              Export
            </Button>
          </div>
        </div>
      </div>

      {/* Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {analyticsMetrics.map((metric, index) => {
          const Icon = metric.icon;
          return (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">{metric.title}</CardTitle>
                <Icon className={`h-4 w-4 text-${metric.color}-500`} />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold text-gray-900">{metric.value}</div>
                <div className={`flex items-center text-xs ${
                  metric.trendDirection === 'up' ? 'text-green-600' : 'text-red-600'
                }`}>
                  <ArrowUp className="h-3 w-3 mr-1" />
                  {metric.trend} from last week
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center">
              <TrendingUp className="h-5 w-5 mr-2" />
              Chat Volume Over Time
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Chart
              type="line"
              data={chartData.volumeOverTime}
              width={400}
              height={300}
              colors={['#3B82F6', '#10B981']}
            />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center">
              <Star className="h-5 w-5 mr-2" />
              Satisfaction Trends
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Chart
              type="bar"
              data={chartData.satisfactionTrends}
              width={400}
              height={300}
              colors={['#F59E0B']}
            />
          </CardContent>
        </Card>
      </div>

      {/* Agent Performance */}
      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Users className="h-5 w-5 mr-2" />
            Agent Performance
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {agentPerformance.map((agent) => {
              const SatisfactionIcon = getSatisfactionIcon(agent.satisfaction);
              return (
                <div key={agent.id} className="flex items-center justify-between p-4 border rounded-lg">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-2">
                      <Badge variant={agent.status === 'online' ? 'default' : 'secondary'}>
                        {agent.status}
                      </Badge>
                      <div>
                        <div className="font-medium">{agent.name}</div>
                        <div className="text-sm text-gray-600">{agent.sessionsHandled} sessions handled</div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-6 text-sm">
                    <div>
                      <div className="font-medium">Response Time</div>
                      <div className="text-gray-600">{agent.avgResponseTime}</div>
                    </div>
                    <div>
                      <div className="font-medium">Satisfaction</div>
                      <div className={`flex items-center ${
                        getSatisfactionColor(agent.satisfaction) === 'green' ? 'text-green-600' :
                        getSatisfactionColor(agent.satisfaction) === 'yellow' ? 'text-yellow-600' : 'text-red-600'
                      }`}>
                        <SatisfactionIcon className="h-4 w-4 mr-1" />
                        {agent.satisfaction}/5
                      </div>
                    </div>
                    <div>
                      <div className="font-medium">Resolution Rate</div>
                      <div className="text-gray-600">{agent.resolutionRate}%</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>

      {/* Filters and Search */}
      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Filter className="h-5 w-5 mr-2" />
            Filter Sessions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center space-x-4">
            <div className="flex-1">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  placeholder="Search sessions..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
            </div>
            <Button
              variant="outline"
              onClick={() => setShowPeriodFilter(true)}
              className="h-10 px-3 border-gray-300 bg-white hover:bg-gray-50 flex items-center gap-2 rounded-full"
            >
              <Calendar className="h-4 w-4 text-gray-600" />
              <span className="text-gray-700 text-sm">
                {filterPeriod === '24hours' ? 'Last 24 Hours' :
                 filterPeriod === '7days' ? 'Last 7 Days' :
                 filterPeriod === '30days' ? 'Last 30 Days' :
                 filterPeriod === '90days' ? 'Last 90 Days' :
                 filterPeriod === '1year' ? 'Last Year' :
                 'Filter by period'}
              </span>
              <ChevronDown className="h-4 w-4 text-gray-400" />
            </Button>
            <Button
              variant="outline"
              onClick={() => setShowAgentFilter(true)}
              className="h-10 px-4 border-gray-300 bg-white hover:bg-gray-50 flex items-center justify-between w-48"
            >
              <span className="text-gray-700">
                {filterAgent === 'all' ? 'All Agents' :
                 agents.find(a => (a.id || a.agentId) === filterAgent)?.name || 'Filter by agent'}
              </span>
              <ChevronDown className="h-4 w-4 text-gray-400 ml-2" />
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Recent Sessions */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <MessageSquare className="h-5 w-5 mr-2" />
            Recent Chat Sessions ({recentSessions.length})
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {recentSessions.map((session) => {
              const SatisfactionIcon = session.satisfaction ? getSatisfactionIcon(session.satisfaction) : null;
              return (
                <div key={session.id} className="p-4 border rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3 mb-2">
                        <h3 className="text-lg font-semibold">{session.id}</h3>
                        <Badge variant={session.status === 'resolved' ? 'default' : 'secondary'}>
                          {session.status}
                        </Badge>
                        {session.satisfaction && (
                          <div className={`flex items-center ${
                            getSatisfactionColor(session.satisfaction) === 'green' ? 'text-green-600' :
                            getSatisfactionColor(session.satisfaction) === 'yellow' ? 'text-yellow-600' : 'text-red-600'
                          }`}>
                            <SatisfactionIcon className="h-4 w-4 mr-1" />
                            {session.satisfaction}/5
                          </div>
                        )}
                      </div>
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Session Details:</h4>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600">
                          <div>
                            <span className="font-medium">Customer:</span> {session.customerName}
                          </div>
                          <div>
                            <span className="font-medium">Subject:</span> {session.subject}
                          </div>
                          <div>
                            <span className="font-medium">Agent:</span> {session.agentName}
                          </div>
                          <div>
                            <span className="font-medium">Duration:</span> {session.duration}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-6 text-sm text-gray-600">
                        <div className="flex items-center">
                          <MessageSquare className="h-4 w-4 mr-1" />
                          <span>{session.messagesCount} messages</span>
                        </div>
                        <div className="flex items-center">
                          <Calendar className="h-4 w-4 mr-1" />
                          <span>Started: {new Date(session.startedAt).toLocaleString()}</span>
                        </div>
                        {session.endedAt && (
                          <div className="flex items-center">
                            <CheckCircle className="h-4 w-4 mr-1" />
                            <span>Ended: {new Date(session.endedAt).toLocaleString()}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>

      {/* Quick Actions */}
      <Card className="mt-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Zap className="h-5 w-5 mr-2" />
            Quick Actions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <Button className="h-20 flex flex-col items-center justify-center space-y-2">
              <BarChart3 className="h-6 w-6" />
              <span>View Reports</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col items-center justify-center space-y-2">
              <Download className="h-6 w-6" />
              <span>Export Data</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col items-center justify-center space-y-2">
              <Settings className="h-6 w-6" />
              <span>Analytics Settings</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col items-center justify-center space-y-2">
              <RefreshCw className="h-6 w-6" />
              <span>Refresh Data</span>
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Period Filter Modal */}
      <SingleSelectFilterModal
        isOpen={showPeriodFilter}
        onClose={() => setShowPeriodFilter(false)}
        onSelect={(value) => {
          setFilterPeriod(value);
          setShowPeriodFilter(false);
        }}
        selectedValue={filterPeriod}
        options={[
          { value: '24hours', label: 'Last 24 Hours' },
          { value: '7days', label: 'Last 7 Days' },
          { value: '30days', label: 'Last 30 Days' },
          { value: '90days', label: 'Last 90 Days' },
          { value: '1year', label: 'Last Year' }
        ]}
        title="Filter by Period"
        placeholder="Select period"
        icon={Calendar}
        searchPlaceholder="Search periods..."
      />

      {/* Agent Filter Modal */}
      <SingleSelectFilterModal
        isOpen={showAgentFilter}
        onClose={() => setShowAgentFilter(false)}
        onSelect={(value) => {
          setFilterAgent(value);
          setShowAgentFilter(false);
        }}
        selectedValue={filterAgent}
        options={[
          { value: 'all', label: 'All Agents' },
          ...agents.map(agent => ({
            value: agent.id || agent.agentId || agent.email,
            label: agent.name || agent.fullName || agent.email,
            description: agent.email || agent.department
          }))
        ]}
        title="Filter by Agent"
        placeholder="Select agent"
        icon={Users}
        searchPlaceholder="Search agents..."
      />
    </div>
  );
};

export default ChatAnalytics;
